import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ViewChild, ElementRef } from '@angular/core';
import { CategoryService } from '../category.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrl: './events.component.css'
})
export class EventsComponent {

  textInput: string = '';
  openSection: string = '';
  documentFile: File | null = null;
  noOptionField: string = '';
  profileData: any;
  defaultCategoryId: number = 0;
  categoryId: any;
  voucherCategories: any[] = [];
  isUploading: boolean = false;


  currentStep: string | null = null;
  mobileVerified: boolean = false;
  firmDetailsValid: boolean = false;
  mobileNumber: any = '';
  firm_name: any = '';
  refName: any = '';
  state: any = '';
  city: any = '';

  statesAndCities: any[] = [];
  dropdownoptionState: any = '';
  dropdownoptionCity: any = '';
  selectedState: any = '';
  selectedCity: any = '';
  cities: any[] = [];

  // currentStep: string | null = null;

  token : any = '609615431cd8d539b733876c7e0c511dSAGLcHZ6nxEBnE4XlJ1nmcPTZaOXOGIXW';

  constructor(private http: HttpClient,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router,
    private scroller: ViewportScroller,
    private fb: FormBuilder
  ) {}

  ngOnInit() : void{
    window.scrollTo(0, 0);
    this.profileData = localStorage.getItem('profileData');

    // this.getStatesAndCities();

    // fetch categories
    this.fetchVoucherCategories();
    this.route.queryParams.subscribe(params => {
      this.categoryId = +params['categoryId'];
    });      
  }

  toggleSection(section: string) {
    if (this.openSection === section) {
      this.openSection = '';
    } else {
      this.openSection = section;

      setTimeout(() => {
        if (section === 'text') {
          this.scroller.scrollToAnchor('divNote');

        } else if (section === 'document') {
          this.scroller.scrollToAnchor('divSelfie');
        }
      }, 100);
    }
  }

  fetchVoucherCategories(): void {
    this.categoryService.getCategoryList().subscribe(response => {
      this.voucherCategories = response.response.data;

      // Automatically select first category as default
      if (this.voucherCategories?.length) {
        this.defaultCategoryId = this.voucherCategories[0].id; // adjust field name if different
      }
    });
  }

  redirectToVoucherPage(categoryId: number): void {
    this.router.navigate(['/giftvoucher'], { queryParams: { categoryId } });
  }

  // Folder upload function
  uploadFromFolder(event: any): void {
    console.log('Folder upload clicked');
    const fileInput = event.target.files[0];
    if (fileInput) {
      this.documentFile = fileInput;
    }
  }

  // Document Upload
  uploadDocument(): void {
    const userCode = JSON.parse(this.profileData).user_code;
    const event_type = localStorage.getItem('event_type') as string;
    const event_code = localStorage.getItem('event_code') as string;
    if (this.documentFile) {
      const formData = new FormData();
      formData.append('document_file', this.documentFile);
      formData.append('button_name', 'Picture Upload');
      formData.append('document_file', this.documentFile.name);
      formData.append('user_code', userCode);
      formData.append('event_type', event_type);
      formData.append('event_code', event_code);
      formData.append('is_active', '1');
      formData.append('token', this.token);

      this.categoryService.insertEventAction(formData).subscribe(response => {
        console.log('Document upload response:', response);
        alert('🌈 Joyful Pose Has Been Captured! Thanks for Spreading Joy!');

        if (this.defaultCategoryId) {
          this.redirectToVoucherPage(this.defaultCategoryId);
        } else {
          console.error('No category ID found to redirect');
        }
      });
    }
  }

}
